import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { assertEnv } from './lib/env';
import './index.css';

// Verify the build was produced with all required VITE_* env vars set.
// In production, missing vars render a visible error page and halt React
// mounting (better than letting the app limp along and fail in obscure
// ways like "Unexpected token '<'" on JSON.parse). In dev, only warns.
assertEnv();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
